export { Icon } from "./components/icon";
export type { IconProps } from "./components/icon";
export type { IconName } from "./constants";
export type { CustomIconName } from "./custom-icons";
export type { IconSize } from "./utils";
